import React, { useState } from "react";
import {
  Box,
  Card,
  Grid,
  TextField,
  InputAdornment,
  Menu,
  MenuItem,
  IconButton,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination
} from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";
import MoreVertIcon from "@mui/icons-material/MoreVert";

const EventTable = ({ data, columns, page, rowsPerPage, setPage, setRowsPerPage, totalCount }) => {
  const [search, setSearch] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuRowId, setMenuRowId] = useState(null);

  const handleMenuOpen = (event, id) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setMenuRowId(id);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setMenuRowId(null);
  };

  const filteredRows = data?.filter((row) =>
    JSON.stringify(row).toLowerCase().includes(search.toLowerCase())
  );

  return (
    <Card sx={{ borderRadius: "16px", padding: 2 }}>
      {/* 🔍 Search Bar Only (NO HEADING) */}
      <Grid container justifyContent="flex-start" alignItems="center">
        <Grid item>
          <TextField
            size="small"
            label="Search"
            placeholder="Search event name or location"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            sx={{ background: "#F5F5F5", borderRadius: "8px", width: "500px", color: '#8C8C8C' }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
      </Grid>

      {/* Table */}
      <Box mt={3}>
        <Table>
          <TableHead sx={{ background: "#F5F5F5" }}>
            <TableRow>
              {columns.map((col) => (
                <TableCell sx={{ color: '#333333', fontWeight: '600' }} key={col.id}>{col.label}</TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {filteredRows
              ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => (
                <TableRow key={row.id} hover>
                  {columns.map((col) => (
                    <TableCell key={col.id} sx={{ color: "var(--text-primary, #000000DE)" }}>
                      {col.template ? col.template(row) : row[col.id]}
                    </TableCell>
                  ))}

                  {/* Action column handled through template */}
                </TableRow>
              ))}
          </TableBody>
        </Table>

        {/* Pagination */}
        <TablePagination
          component="div"
          count={totalCount}
          page={page}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[10, 20, 50, 100]}
          onPageChange={(e, newPage) => setPage(newPage)}
          onRowsPerPageChange={(e) => {
            setRowsPerPage(parseInt(e.target.value));
            setPage(0);
          }}
        />
      </Box>
    </Card>
  );
};

export default EventTable;
